export const getClientId = ()=> localStorage.getItem("client_id");
export const getRoomId = ()=> localStorage.getItem("room_id");
export const setClientId = (clientId: string)=> localStorage.setItem("client_id", clientId);
export const setRoomId = (roomId: string)=> localStorage.setItem("room_id",roomId);
